<div class="container">
  <div *ngFor="let item of list" class="list-item">
    <div class="icons">
      <dap-lib-background-icon
        [name]="item.icon"
        [svgAriaLabel]="item.icon"
        [iconSize]="iconSize"
        [iconColor]="getIconColor()"
        [backgroundSize]="backgroundSize"
        [backgroundColor]="getIconBackgroundColor()"
      ></dap-lib-background-icon>
    </div>
    <div class="body-3">
      {{ item.translationKey | translate | htmlEntityDecode }}
    </div>
  </div>
</div>
